import React from 'react';

import gogglesButtonsView from '../../../main/assets/images/fpvonepilot/goggles-buttons.webp';
import gogglesButtonsCloserView from '../../../main/assets/images/fpvonepilot/goggles-buttons-closer.webp';

export const GogglesButtons = ({ windowWidth }: { windowWidth: number }) => {
  return (
    <section className="fpv-pilot-buttons-section">
      <div className="fpv-pilot-buttons-text">
        <div className="fpv-pilot-buttons-titles">
          <h3 className="fpv-pilot-buttons-subtitle">experience</h3>
          <h2 className="fpv-pilot-buttons-title">
            Portal to the digital world
          </h2>
        </div>
        <p className="fpv-pilot-buttons-description">
          High-Speed multipurpose interface for future expansions.
        </p>
      </div>
      <div className="fpv-pilot-buttons-image">
        <img
          src={
            windowWidth > 500 ? gogglesButtonsView : gogglesButtonsCloserView
          }
          alt="Top View of the Device's Buttons, in Focus and Shining"
          className="fpv-pilot-buttons-product"
        />
      </div>
    </section>
  );
};
